import { useCallback, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { closeMenuSaveSharePopUp, getMenuState } from '../../store/menuSlice'
import { TdsSideMenuCloseButton, TdsSideMenuItem } from '@scania/tegel-react'
import { openGvPanel, setGvSidePanelContent } from '../../store/sidePanelSlice'
import { SidePanelContent } from '../../store/types'
import { getMarketSettingsState } from '../../store/appSlice'
import { TextId, useTextsV2 } from '../../utils/useTexts'
import { TestElementTypeId } from '../../types/TestAttributeId'

const PopUpWrapperRoot = styled.div`
  width: 250px;
  border: 1px solid var(--tds-grey-300);
  background-color: white;
  position: absolute;
  right: 0px;
  top: 124px;
  z-index: 1;
`

export const PopUpSaveshareMenu = (): JSX.Element => {
  const dispatch = useAppDispatch()
  const ref = useRef<HTMLDivElement | null>(null)
  const t2 = useTextsV2()
  const popupIsOpen = useAppSelector(getMenuState).menuSaveSharePopUpIsOpen
  const marketSettings = useAppSelector(getMarketSettingsState)

  const showShareIcon =
    marketSettings?.shareEmailEnabled ||
    marketSettings?.shareFacebookEnabled ||
    marketSettings?.shareLinkEnabled ||
    marketSettings?.shareWhatsappEnabled

  const handleClose = () => {
    dispatch(closeMenuSaveSharePopUp())
  }

  const handleSaveClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    dispatch(openGvPanel())
    dispatch(setGvSidePanelContent(SidePanelContent.save))
    dispatch(closeMenuSaveSharePopUp())
  }

  const handleShareClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    dispatch(openGvPanel())
    dispatch(setGvSidePanelContent(SidePanelContent.share))
    dispatch(closeMenuSaveSharePopUp())
  }

  const handleUserClickOnScreen = useCallback(
    (e: MouseEvent) => {
      if (!popupIsOpen) {
        return
      }
      const currentElement = ref.current
      if (!currentElement?.contains(e.target as Node)) {
        dispatch(closeMenuSaveSharePopUp())
      }
    },
    [ref, dispatch, popupIsOpen],
  )

  useEffect(() => {
    document.addEventListener('click', handleUserClickOnScreen)
    return () => {
      document.removeEventListener('click', handleUserClickOnScreen)
    }
  }, [handleUserClickOnScreen])

  return (
    <PopUpWrapperRoot ref={ref}>
      <TdsSideMenuCloseButton onClick={handleClose}></TdsSideMenuCloseButton>

      <TdsSideMenuItem
        onClick={handleSaveClick}
        data-test-element-type={TestElementTypeId.GuidedViewPopupSaveMenu}
      >
        <button>{t2(TextId.LABEL_ACTION_SAVE)}</button>
      </TdsSideMenuItem>
      {showShareIcon && (
        <TdsSideMenuItem
          onClick={handleShareClick}
          data-test-element-type={TestElementTypeId.GuidedViewPopupShareMenu}
        >
          <button>{t2(TextId.LABEL_ACTION_SHARE)}</button>
        </TdsSideMenuItem>
      )}
    </PopUpWrapperRoot>
  )
}
